import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import type { MarketplaceStore } from '../../../../../component-decorators/with-marketplace-store';
import { composer } from '../../../../../component-decorators/composer';
import { ModalNames } from '../../../../modals/modals';
import { TextButton } from '@wix/design-system';
import React from 'react';
import { CountriesPopover } from './countries-popover';

export interface IOtherCountriesProps extends Partial<WithTranslationProps> {
  popoverElementTitle: string;
  marketplaceStore?: MarketplaceStore;
  appId: string;
  isMobile: boolean;
  popoverTitle: string;
  countries: any;
  contactMail?: string;
  onSupportClick?: any;
  madeByWix: boolean;
}
export const OtherCountries = composer()
  .withMarketplaceStore()
  .withTranslation()
  .compose(
    ({
      popoverElementTitle,
      isMobile,
      popoverTitle,
      countries,
      contactMail,
      appId,
      onSupportClick,
      marketplaceStore,
      t,
      madeByWix,
    }: IOtherCountriesProps) => {
      const footerTwo = madeByWix
        ? t('solution.page.tagsBoxAvailabilityPopoverFooter2-wix')
        : t('solution.page.tagsBoxAvailabilityPopoverFooter2');
      const openOtherCountriesModal = () => {
        marketplaceStore.openModal(ModalNames.OTHER_COUNTRIES_MODAL, {
          subtitle: `${popoverTitle}`,
          closeModal: () => marketplaceStore.closeAllModals(),
          countries,
          footerTwo: `${footerTwo}`,
          onSupportClick: () => onSupportClick(),
        });
      };

      return isMobile ? (
        <TextButton onClick={openOtherCountriesModal}>
          {popoverElementTitle}
        </TextButton>
      ) : (
        <CountriesPopover
          popoverTitle={popoverTitle}
          popoverElementTitle={popoverElementTitle}
          countries={countries}
          popoverFooter1={t('solution.page.tagsBoxAvailabilityPopoverFooter1')}
          popoverFooter2={footerTwo}
          contactMail={contactMail}
          appId={appId}
          onSupportClick={onSupportClick}
        />
      );
    },
  );
